package com.devi3east.bashbuddy.di

import com.devi3east.bashbuddy.clientFactory.HttpClientFactory
import org.koin.dsl.module
import com.devi3east.bashbuddy.dbFactory.DatabaseFactory
import com.devi3east.bashbuddy.features.common.util.UrlOpener
import com.devi3east.bashbuddy.preferences.MultiplatformSettingsFactory
import com.devi3east.bashbuddy.stripe.JsUrlOpener

val jsModules = module {
    single { DatabaseFactory() }
    single { MultiplatformSettingsFactory() }
    single<UrlOpener> { JsUrlOpener() }
}

fun initKoinJs() = initKoin(
    factory = HttpClientFactory(null),
    additionalModules = listOf(jsModules)
)